import React, { Fragment, useState, useEffect } from "react";
import Row from "canvas-core-react/lib/Row";
import Column from "canvas-core-react/lib/Column";
import Margin from "canvas-core-react/lib/Margin";
import PrimaryButton from "canvas-core-react/lib/PrimaryButton";
import Checkbox from "canvas-core-react/lib/Checkbox";
import ModalEmail from "./modalEmail/modal-email.js";
import ModalPhone from "./modalPhone/modal-phone.js";
import Grid from "canvas-core-react/lib/Grid";
import BannerMobile from "./banner/Mobile";
import BannerWeb from "./banner/Web";
import TextSubtitle from "canvas-core-react/lib/TextSubtitle";
import ContinueButton from "canvas-core-react/lib/ContinueButton";
import TextBody from "canvas-core-react/lib/TextBody";
import { WealthService } from "../../services/";
import { checkout } from "cldffecop-tagging-utils";
import { useAppContext } from "../../context/AppContext";
import { RetryErrorComponent } from "../../components/index.js";
import "./ContactabilityStep.scss";

const ContactabilityStep = () => {
  const {
    changeItem: setContext,
    state: context,
    displayError,
  } = useAppContext();

  const wealthService = new WealthService();

  const [modalEmail, setModalEmail] = useState(false);
  const [modalPhone, setModalPhone] = useState(false);

  const [consent, setConsent] = useState({
    auth_type: "",
    consent_text: "Cargando...",
    creation_time: "",
    is_active: "",
    sign_provider: "",
    version: "",
  });

  const getConsent = () => {
    setContext({ loading: true });
    wealthService
      .consent({
        channel: "WPUB",
        product: "WEALTH",
        flowType: "ONBOARDING_WEALTH_CUSTOMER",
        consentType: "GENERAL",
        productName: "CONTACT_DATA_VALIDATION",
      })
      .then((res) => {
        let value = res;
        let row = value[0];
        setConsent({
          auth_type: row.auth_type,
          consent_text: row.consent_text,
          creation_time: row.creation_time,
          is_active: row.is_active,
          sign_provider: row.sign_provider,
          version: row.version,
        });
      })
      .catch((error) => {
        displayError(
          error,
          getConsent,
          <RetryErrorComponent retryCallBack={getConsent} />
        );
      })
      .finally(() => {
        setContext({ loading: false });
      });
  };

  useEffect(() => {
    getConsent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const modalPhoneOpen = () => {
    setModalPhone(true);
  };

  const modalPhoneClose = async () => {
    await setModalPhone(false);
  };

  const modalEmailClose = async () => {
    await setModalEmail(false);
  };
  const modalEmailOpen = async () => {
    await setModalEmail(true);
  };

  const changeChecked = (input) => {
    setContext({
      checkedStep: {
        ...context.checkedStep,
        stepContactability: input,
      },
    });
  };

  const continueNextStep = async () => {
    await wealthService
      .consentSave({
        customer_id: context.subjectData.rut,
        customer_ip: "",
        channel_type: "WPUB",
        product_type: "WEALTH",
        flow_type: "ONBOARDING_WEALTH_CUSTOMER",
        consent_type: "GENERAL",
        product_name: "GENERAL_DATA",
        version: consent.version,
      })
      .then((res) => {
        setContext({
          clientStep: "stepSelectValidationOptions",
        });
        checkout({
          step: "2",
          stepName: "step-contactability",
          extraDimension: {
            step: "2",
            contact: {
              email: context.subjectData.email,
              phone: context.subjectData.phone,
            },
          },
        });
      })
      .catch((error) => {
        displayError(error, continueNextStep, <RetryErrorComponent retryCallBack={continueNextStep}/>);
      });
  };

  return (
    <Fragment>
      <div className={"contactability-step"}>
        <BannerMobile />
        <BannerWeb />
        <Grid className={"container-step-web"}>
          <Row>
            <Column xs={4} sm={8} md={8} mdOffset={2} lg={8} lgOffset={2}>
              <Row>
                <Column>
                  <Margin
                    xs={[0, 0, 12, 0]}
                    sm={[0, 0, 12, 0]}
                    md={[0, 0, 12, 0]}
                    lg={[0, 0, 12, 0]}
                  >
                    <TextSubtitle
                      component="p"
                      type="2"
                      id="content-contactability"
                    >
                      <strong>
                        {context.subjectData.name}, necesitamos que valides tus
                        datos de contacto, los cuales confirmarás cuando
                        ingreses el código verificador que llegará a estos
                        canales en el momento que se solicite.
                      </strong>
                    </TextSubtitle>
                  </Margin>
                </Column>
              </Row>
              <Row>
                <Column>
                  <Margin
                    xs={[0, 0, 12, 0]}
                    sm={[0, 0, 12, 0]}
                    md={[0, 0, 12, 0]}
                    lg={[0, 0, 12, 0]}
                  >
                    <div
                      id="checkbox-phone-tag"
                      onClick={context.isValidPhone ? null : modalPhoneOpen}
                    >
                      <Checkbox
                        id="checkbox-phone"
                        name="checkbox-phone"
                        value="text"
                        label="Número telefónico"
                        checked={context.isValidPhone}
                        style={{ cursor: "pointer !important" }}
                      />
                    </div>
                  </Margin>
                </Column>
              </Row>
              <Row>
                <Column>
                  <Margin
                    xs={[0, 0, 12, 0]}
                    sm={[0, 0, 12, 0]}
                    md={[0, 0, 12, 0]}
                    lg={[0, 0, 12, 0]}
                  >
                    <div
                      id="checkbox-email-tag"
                      onClick={context.isValidEmail ? null : modalEmailOpen}
                    >
                      <Checkbox
                        id="checkbox-email"
                        name="checkbox-email"
                        value="text"
                        label="E-mail"
                        checked={context.isValidEmail}
                      />
                    </div>
                  </Margin>
                </Column>
              </Row>
              <Row>
                <Column>
                  <Margin
                    xs={[0, 0, 36, 0]}
                    sm={[0, 0, 36, 0]}
                    md={[0, 0, 36, 0]}
                    lg={[0, 0, 36, 0]}
                  >
                    <div>
                      <div className="buttons-mobile align-items--end">
                        <PrimaryButton
                          id="button-next-step"
                          disabled={
                            !context.isValidPhone ||
                            !context.isValidEmail ||
                            !context.checkedStep.stepContactability
                          }
                          onClick={continueNextStep}
                        >
                          Continuar
                        </PrimaryButton>
                      </div>
                      <div className="buttons-web align-items--end">
                        <ContinueButton
                          id="button-next-step"
                          disabled={
                            !context.isValidPhone ||
                            !context.isValidEmail ||
                            !context.checkedStep.stepContactability
                          }
                          onClick={continueNextStep}
                        >
                          Continuar
                        </ContinueButton>
                      </div>
                    </div>
                  </Margin>
                </Column>
              </Row>
              <Row>
                <Column>
                  <Margin
                    xs={[0, 0, 36, 0]}
                    sm={[0, 0, 36, 0]}
                    md={[0, 0, 36, 0]}
                    lg={[0, 0, 36, 0]}
                  >
                    <Checkbox
                      id="checkedStepContactability"
                      label={
                        <TextBody component="span">
                          {consent.consent_text}
                        </TextBody>
                      }
                      name="checkedStepContactability"
                      checked={context.checkedStep.stepContactability}
                      onChange={() =>
                        changeChecked(!context.checkedStep.stepContactability)
                      }
                    />
                  </Margin>
                </Column>
              </Row>
            </Column>
          </Row>
        </Grid>

        {modalEmail && <ModalEmail onClose={modalEmailClose} />}

        {modalPhone && <ModalPhone onClose={modalPhoneClose} />}
      </div>
    </Fragment>
  );
};

export default ContactabilityStep;
